import React from "react";
import FarmerImg from "../../images/gbrCBN/CBNImg3.webp";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import AdvisorImg from "../../images/AnimalVet1.jpg";
import HomeSubSection from "../WebSite/HomeSubSection/HomeSubSection";
import HeaderComponent from "../WebSite/Header/HeaderComponent";
import FooterComponent from "../WebSite/Footer/FooterComponent";
import CBN from "../../images/GBR Care (CBN Network) - GBR Care - 16-05-2024 C.gif";
import { Col, Container, Row } from "react-bootstrap";
import ProductionManagerImg from "../../images/gbrPN/PNImg5.webp";

// Exporting the ARNNetwork functional component
export default function ARNNetwork() {
  return (
    <>
      {/* Header section */}
      <HeaderComponent />

      {/* Updates Banner for ARN Network */}
      <UpdatesBanner
        className="cbnbg text-white"
        bannerTitle="Seed to Sale"
        bannerbodycopy1={[
          <span key="1">
            CBO & Agro Dealers can BUILD, OWN, MANAGE & OPERATE to help farmers{" "}
          </span>,
          <br key="2" className="d-lg-block d-none" />,
          <span key="3">with everything they need from seed to sale</span>,
        ]}
        demo="true"
        bannerbodycopy="Local Trade | Quality Inputs | Insurance | Advisory | Capital"
      />

      {/* Managed Agri-Retailer Network Image Section */}
      <div className="mt-5">
        <h4 className="container-title text-center mx-md-4">
          Managed Agri-Retailer Network
        </h4>
        <Container>
          <Row className="justify-content-center">
            <Col md={6} sm={12}>
              <img
                className="w-100 h-100 cursor-initial"
                src={CBN}
                alt="Infographics"
              />
            </Col>
          </Row>
        </Container>
      </div>

      {/* ARN Community Members Section */}
      <div className="subSectionWrapper">
        <h2 className="text-center container-title">ARN COMMUNITY MEMBERS</h2>

        {/* Farmer Advisors Card */}
        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          className3="image16"
          description="Farmer advisors are members of the Agri-retailer network, bridging the gap between farmers and retail services. With their extensive knowledge of local farming practices, they offer personalized advice on crop management, pest control, soil health, and agricultural inputs. Their expertise and trust-building efforts significantly enhance the productivity and sustainability of local farming communities."
          descriptionTitle="Farmers' Advisors"
          src={AdvisorImg}
          href2="auth/3/signup"
          buttoncont2="Register"
          onClick={() => {
            localStorage.setItem("userType", "ADVISORS");
          }}
          userType="Trainer"
          buttoncont3="Explore Community"
          href3="/community"
        />

        {/* Farmer Card */}
        <HomeSubSection
          className="rowReverseAbout--mod borderedCards borderedCards--mod"
          className3="image18"
          description="Farmers are essential members of the Agri-retailer network, where they can access a wide range of plant and animal health care products. This network provides them with the resources and support needed to maintain the health and productivity of their crops and livestock, ensuring sustainable and efficient farming practices."
          descriptionTitle="Farmer"
          src={FarmerImg}
          href2="auth/3/signup"
          buttoncont2="Register"
          buttoncont3="Explore Community"
          href3="/community"
          onClick={() => {
            localStorage.setItem("userType", "Grower");
          }}
        />

        {/* Agri-Retailer Card */}
        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          className3="agri-retailer-role"
          description="Agri-retailers are businesses that specialize in selling agricultural inputs such as seeds, fertilizers, pesticides, and farm equipment to farmers. They often provide a wide range of products and services tailored to the needs of the agricultural community, including agronomic advice, soil testing, and crop protection solutions. Agri-retailers play a crucial role in the agricultural supply chain, facilitating the distribution of essential inputs to farmers and supporting their efforts to maximize yields and profitability."
          descriptionTitle="Agri Retailer"
          src={ProductionManagerImg}
          href2="auth/3/signup"
          buttoncont2="Register"
          buttoncont3="Explore Community"
          href3="/community"
          description1="Farm Machinery Retailers | Nutrition Retailers | Agri Input Retailers"
        />
      </div>

      {/* Footer section */}
      <FooterComponent />
    </>
  );
}

